import { ItemMenuAcessoRapido } from "../modelo/ItemMenuAcessoRapido";
import UsuarioStore from '../store/UsuarioStore';
import MenuAcessoRapidoStore from "../store/MenuAcessoRapidoStore";

export const itensMenuPermitidos = (assistenteMinutas?: boolean): ItemMenuAcessoRapido[] => {
    if (assistenteMinutas) {
        return MenuAcessoRapidoStore.itensMenuAcessoRapidoAM
            .filter(item => {
                if (item.grupos.includes('usuario')) {
                    return !item.hideFor;
                }
                if (item.grupos.find(grupo => UsuarioStore.usuarioTemPapel(grupo))) {
                    return !item.hideFor;
                }
                return !!(item.grupos.includes('administrador') && UsuarioStore.isSuperAdministrador()) && !item.hideFor;
            });
    } else {
        return MenuAcessoRapidoStore.itensMenuAcessoRapido
            .filter(item => {
                if (item.grupos.includes('usuario')) {
                    return !item.hideFor;
                }
                if (item.grupos.find(grupo => UsuarioStore.usuarioTemPapel(grupo))) {
                    return !item.hideFor;
                }
                return !!(item.grupos.includes('administrador') && UsuarioStore.isSuperAdministrador()) && !item.hideFor;
            });
    }
};
